import React, { useEffect, useRef, useState } from "react";
import { fetchHomepageData, HomePageData } from "../api/homepage";
import Banner from "../components/homePage/Banner";
import ProductList from "../components/homePage/ProductList";

const HomePage = () => {
  const productListRef = useRef<HTMLDivElement | null>(null);

  const scrollToProducts = () => {
    productListRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const [homePageData, setHomePageData] = useState<HomePageData>();

  useEffect(() => {
    fetchHomepageData().then((data) => {
      setHomePageData(data);
    });
  }, []);

  const products =
    homePageData?.products.filter(
      (product) => product !== null && (product ?? undefined)
    ) ?? [];

  return (
    <>
      <Banner
        brandInfo={homePageData?.brand}
        data={homePageData?.hero}
        scrollToProducts={scrollToProducts}
      />
      <div ref={productListRef}>
        <ProductList products={products} />
      </div>
    </>
  );
};

export default HomePage;
